<template>
  <div
    class="d-flex back-color image-modal-wrapper generic-modal position-fixed align-items-center justify-content-center position-fixed">
    <div class="modal-inner  align-items-center justify-content-center d-flex h-100 w-100">
      <div class="width-video bm-modal-content bg-white px-24 pt-20  pb-xl-35 pb-lg-29 pb-md-29 position-fixed rounded rounded-4 pt-xl-26 pt-lg-20" >
        <div
          class="bm-modal-body border-0 mt-3">
          <p class="text-center modal-heading text-dark-gray fs-20 mb-0 heading-styling">Warning: Enabling Video Mode </p>
          <div class="tabs-wrapper">
            <div class="tabs-inner d-flex justify-content-center text-styling ">
              You are attempting to enable video mode, but your current project has pages of different sizes. If you proceed, all pages will be automatically resized to match page 1, which could cause unexpected layout changes or distortion. There is no way to undo this action, so we recommend saving your order before proceeding.
            </div>

          </div>
        </div>
        <div
          class="justify-content-between bm-modal-footer mt-xl-30 mt-lg-24  mt-md-24 d-flex  align-items-center">
          <button
            class="lf-btn blue-border-btn action-btn bg-white"
            @click.stop="cancelationToVideo">Cancel</button>
          <button
            class="bm-primary-btn action-btn"
            @click.stop="confirmationToVideo">Continue</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:  'VideoConfirmationModal',
  props: {
    product: Object,
  },
  methods: {
    confirmationToVideo() {
      this.$store.commit('activeProduct/updateVideoConfirmationModel', false);
      EventBus.$emit(ApplicationEventTypes.ProductPageEvents.PRODUCT_PAGES_SHOULD_BE_SAME);
    },
    cancelationToVideo() {
      this.$store.commit('activeProduct/updateVideoConfirmationModel', false);
      EventBus.$emit('resetToggleButton', false);
    },
  },
};
</script>

<style scoped>
.back-color{
  background: rgba(237, 237, 237, 0.6);
}
.width-video{
  width: 50vw !important;
}
.heading-styling{
  font-family: "Open Sans";
  font-size: 16px !important;
  font-weight: 700 !important;
  margin-bottom: 12px !important;
}
.text-styling{
  font-family: "Open Sans";
  font-size: 12px !important;
  font-weight: 500 !important;
  margin-bottom: 10px;
}
.text-note{
  font-family: "Open Sans";
  font-size: 12px !important;
  font-weight: 600 !important;
  margin-bottom: 10px;
}
</style>
